import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { Handler } from "@insite/client-framework/HandlerCreator";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { CatalogPage } from "@insite/client-framework/Services/CategoryService";
import * as ProductServiceV2 from "@insite/client-framework/Services/ProductServiceV2";
import { chain, SetExpandTokens } from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

interface Parameter {
    queryString: string;
    path: string;
    isSearch: boolean;
}

export interface DisplayProductsResult {
    products?: ProductModel[];
    productInfosByProductId: SafeDictionary<ProductInfo>;
    productFilters: ProductFilters;
    isFiltered: boolean;
    unfilteredApiParameter?: ProductServiceV2.GetProductCollectionApiV2Parameter;
    filteredApiParameter?: ProductServiceV2.GetProductCollectionApiV2Parameter;
    catalogPage?: CatalogPage;
}

interface Props {
    apiParameter: ProductServiceV2.GetProductCollectionApiV2Parameter;
    idByPath?: SafeDictionary<string>;
    result: DisplayProductsResult;
    pricingLoaded?: true;
    expandTokens?: ProductServiceV2.ProductExpandTokens;
}

type HandlerType = Handler<Parameter, Props>;

export const AddToExpandTokens: HandlerType = props => {
    if(props.expandTokens) {
            props.expandTokens.push("properties");
    }
};

addToChainAfter(chain, SetExpandTokens, AddToExpandTokens);
